var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.buttons),function(button,action){return _c('svgicon',{key:action,attrs:{"name":button.icon},on:{"click":function($event){return _vm.$emit('action', action)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }